<template>
  <div class="home-v2">
    <Loading v-if="$store.state.globalLoading" />
    <ImportDataPO v-if="$store.state.tkdnStore.importModalShow" />
    <div style="display:flex">
      <Sidebar />
      <Main />
    </div>
    <div class="request-container">
      <router-view />
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  components: {
    Loading: () => import('@/components/V2/GlobalLoading'),
    Sidebar: () => import('@/components/dashboard/sidebar/sidebar.vue'),
    Main: () => import('@/components/dashboard/main/main.vue'),
    ImportDataPO: () => import('@/components/modal/ImportDataPO'),
  },
  data() {
    return {}
  },
  async created() {
    await this.$store.dispatch('tkdnStore/getRealisasiBelanja')
    await this.$store.dispatch('tkdnStore/getBelanjaDomestik')
    await this.$store.dispatch('tkdnStore/getTkdnCategories')
  },
  computed: {},
  methods: {},
}
</script>
